import * as React from 'react';
import style from './FirstTableRow.scss';
import { TableColumn } from '../TableColumn';
import { TableHeading } from '../../../PageElements/TableHeading';
import { APPEARANCES, Heading } from '../../../PageElements/Heading';

export const FirstTableRow = ({ title, columnTitles }) => (
  <React.Fragment>
    {title && <Heading appearance={APPEARANCES.H3}>{title}</Heading>}
    <div role="row" className={style.tableHeader}>
      {columnTitles.map((columnTitle, index) => (
        <React.Fragment key={columnTitle}>
          <TableColumn index={index + 1} role="columnheader">
            <TableHeading>{columnTitle}</TableHeading>
          </TableColumn>
        </React.Fragment>
      ))}
    </div>
  </React.Fragment>
);
